import { render, staticRenderFns } from "./FPotensiDialog.vue?vue&type=template&id=01b808f4&scoped=true"
import script from "./FPotensiDialog.vue?vue&type=script&lang=js"
export * from "./FPotensiDialog.vue?vue&type=script&lang=js"
import style0 from "./FPotensiDialog.vue?vue&type=style&index=0&id=01b808f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b808f4",
  null
  
)

export default component.exports